/**
 * @file
 * theme behaviors.
 */

import {initMenuToggle} from "./components/MenuToggle/default";
import {initFaqToggle} from "./components/FaqToggle/default";
import {initMenuExpand} from "./components/MenuExpand/default";
import {initPageHeader} from "./components/PageHeader/default";
import {initFontAwesome} from "./vendor/FontAwesome";
import {initSwiper} from "./vendor/Swiper";
import {initMenuHighlighting} from "./components/MenuHighlighting/default";

(function (Drupal) {

  'use strict';

  Drupal.behaviors.rybickyfest = {
    attach (context, settings) {

      /**
       * @return {void}
       */
      function initBaseComponents() {
        initFontAwesome();

        initMenuExpand();
        initFaqToggle();
        initMenuToggle(context);
        initMenuHighlighting();
        initPageHeader();
        initSwiper();
      }

      /**
       * @return {void}
       */
      function reinitBaseComponents() {
      }

      window.reinitBaseComponents = reinitBaseComponents;
      window.initBaseComponents = initBaseComponents;

      initBaseComponents();
      reinitBaseComponents();
    }
  };

} (Drupal));

/* Variables. */


